export default {
    REFRESH_TIME: 10 * 60 * 1000,
    ITEMS_PER_PAGE: 10,
    SORT_DIRECTION_DESCENDING: 'desc',
    SORT_DIRECTION_ASCENDING: 'asc',
    ACTION_GET_CONTROL_ITEMS: {
        CUSTOM: 'CUSTOM',
        ALL: 'ALL',
        ONE_PAGE: 'ONE_PAGE',
    },
};
